// NS-9511 DL - new functionality for online payments			

import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    enabled: [],
    cart: [],
    payment: [],
    receipt: [],
    transaction: [],
    docTypes: []
};

const getters = {
    getEnabled: (state) => state.enabled,
    getCart: (state) => state.cart,
    getPayment: (state) => state.payment,
    getReceipt: (state) => state.receipt,
    getTransaction: (state) => state.transaction,
    getPaymentDocumentTypes: (state) => state.docTypes
};

const actions = {
    async getEnabled(context, data) {
		//console.log('getEnabled',data)
        await axios.post(`${backendUrl()}/getOnlinePaymentEnabled`,
        {
            sessionToken: vuecookie.get('token'),
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
			//console.log('setEnabled',response.data)
            context.commit('setEnabled',response.data)
        }).catch(error => {
			//console.log('getEnabled > error',error)
		})	
    },	
    async getCart(context, data) {
		//console.log('setCart',data)
        return await axios.post(`${backendUrl()}/getOnlinePaymentCart`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents,
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
			//console.log('setCart',response.data)
            context.commit('setCart',response.data)
            return response.data
        }).catch(error => {
			//console.log(error)
		})	
    },	
    async getPayment(context, data) {
        return await axios.post(`${backendUrl()}/getOnlinePaymentPayment`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents,
            amount_paid: data.amount_paid,
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setPayment',response.data)
            return response.data
        })
    },	
    async getReceipt(context, data) {
        return await axios.post(`${backendUrl()}/getOnlinePaymentReceipt`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents,
            hppResponse: data.hppResponse,
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setReceipt',response.data)
            return response.data
        })
    },	
    async getTransaction(context, data) {
        await axios.post(`${backendUrl()}/getOnlinePaymentTransaction`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents,
            payment_id: data.payment_id,
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
			//console.log('setTransaction',response.data)
            context.commit('setTransaction',response.data)
        }).catch(error => {
			//console.log('getTransaction > error',error)
		})	
    },	
    
    async getPaymentMethods(context, data) {
        return await axios.post(`${backendUrl()}/getPaymentMethods`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },

    async getPaymentDocumentTypes(context, data) {
        await axios.post(`${backendUrl()}/getPaymentDocumentTypes`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setPaymentDocumentTypes', response.data)
        })
    },

    async getPaymentConfiguration(context, data) {
        return await axios.post(`${backendUrl()}/getPaymentConfiguration`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },

    async addPaymentConfiguration(context, data) {
        return await axios.post(`${backendUrl()}/addPaymentConfiguration`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },
    
    async deletePaymentConfiguration(context, data) {
        return await axios.post(`${backendUrl()}/deletePaymentConfiguration`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },
    
    async updatePaymentConfiguration(context, data) {
        return await axios.post(`${backendUrl()}/updatePaymentConfiguration`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            return response.data
        })
    },

    async getReceiptData(context, data) {
        return await axios.post(`${backendUrl()}/getReceiptData`, 
        {
            docId: data
        }, 
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    }
};

const mutations = {
    setEnabled:(state, enabled) => (state.enabled = enabled),
    setCart:(state, cart) => (state.cart = cart),
    setPayment:(state, payment) => (state.payment = payment),
    setReceipt:(state, receipt) => (state.receipt = receipt),
    setTransaction:(state, transaction) => (state.transaction = transaction),
    setPaymentDocumentTypes: (state, docTypes) => (state.docTypes = docTypes)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}